type FacilityPlacementArgs = {
	readonly facilityId: number;
	readonly facilityName: string;
	readonly organizationId: number;
	readonly organizationName: string;
};

/** Where a facility sits: its own name and the organization that owns it. */
class FacilityPlacement {
	readonly facilityId: number;
	readonly facilityName: string;
	readonly organizationId: number;
	readonly organizationName: string;

	constructor(args: FacilityPlacementArgs) {
		this.facilityId = args.facilityId;
		this.facilityName = args.facilityName;
		this.organizationId = args.organizationId;
		this.organizationName = args.organizationName;

		Object.freeze(this);
	}
}

export default FacilityPlacement;
